<template>
  <div>
    <a
      ref="contextLink"
      class="header__filter-link"
      :class="{
        'active active--purple': view.group_bys.length > 0,
      }"
      @click="$refs.context.toggle($refs.contextLink, 'bottom', 'left', 4)"
    >
      <i class="header__filter-icon iconoir-book-stack"></i>
      <span class="header__filter-name">{{
        $t('viewGroupBy.groupBy', {
          count: view.group_bys.length,
        })
      }}</span>
    </a>
    <ViewGroupByContext
      ref="context"
      :database="database"
      :view="view"
      :fields="fields"
      :read-only="readOnly"
      :disable-group-by="disableGroupBy"
      :store-prefix="storePrefix"
      @changed="$emit('changed', $event)"
    ></ViewGroupByContext>
  </div>
</template>

<script>
import ViewGroupByContext from '@onedesk/modules/database/components/view/ViewGroupByContext'

export default {
  name: 'ViewGroupBy',
  components: { ViewGroupByContext },
  props: {
    database: {
      type: Object,
      required: true,
    },
    fields: {
      type: Array,
      required: true,
    },
    view: {
      type: Object,
      required: true,
    },
    readOnly: {
      type: Boolean,
      required: true,
    },
    disableGroupBy: {
      type: Boolean,
      required: false,
      default: false,
    },
    storePrefix: {
      type: String,
      required: false,
      default: '',
    },
  },
  emits: ['changed'],
}
</script>
